import React from 'react';
import '../../styles/LegalPages.css';

const PrivacyPolicy = () => {
    return (
        <div className="legal-page">
            <div className="legal-container">
                <div className="legal-content-header">
                    <h1>Privacy Policy</h1>
                    <p className="last-updated">Last Updated: {new Date().toLocaleDateString('en-US')}</p>
                </div>

                <div className="legal-content glass">
                    <section className="legal-section">
                        <h2>1. Data Controller</h2>
                        <p>
                            The data controller responsible for data processing on this website is:
                        </p>
                        <div className="contact-info-legal">
                            <p>
                                <strong>Ferritico AB</strong><br/>
                                c/o Openlab<br/>
                                Valhallavägen 79<br/>
                                114 28 Stockholm, Sweden<br/>
                                <br/>
                                Email: contact@ferritico.com<br/>
                                {/* Temporarily hidden — restore by removing this comment wrapper
                                Phone: +46 (0)8 121 530 03
                                */}
                            </p>
                        </div>
                    </section>

                    <section className="legal-section">
                        <h2>2. Types of Data Processed</h2>
                        <p>
                            We process the following categories of personal data:
                        </p>
                        <ul>
                            <li>Contact data (name, email address, phone number, company name)</li>
                            <li>Usage data (IP address, browser information, visit time)</li>
                            <li>Communication data (messages via contact forms)</li>
                            <li>Cookie data (see Cookies section)</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>3. Purposes of Data Processing</h2>
                        <p>
                            We process your personal data for the following purposes:
                        </p>
                        <ul>
                            <li>Providing and improving our website</li>
                            <li>Processing inquiries via contact forms</li>
                            <li>Customer support and communication</li>
                            <li>Website usage analysis (only with your consent)</li>
                            <li>Marketing and advertising (only with your consent)</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>4. Legal Basis</h2>
                        <p>
                            The processing of your personal data is based on:
                        </p>
                        <ul>
                            <li><strong>Art. 6(1)(a) GDPR</strong> - Consent (e.g., for cookies, newsletters)</li>
                            <li><strong>Art. 6(1)(b) GDPR</strong> - Contract performance (e.g., customer inquiries)</li>
                            <li><strong>Art. 6(1)(f) GDPR</strong> - Legitimate interests (e.g., website security)</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>5. Cookies and Tracking</h2>
                        <p>
                            Our website uses different types of cookies:
                        </p>
                        
                        <h3>5.1 Essential Cookies</h3>
                        <p>
                            These cookies are essential for the website's basic functionality and are 
                            set without your consent.
                        </p>
                        
                        <h3>5.2 Analytics Cookies</h3>
                        <p>
                            With your consent, we use analytics tools like Google Analytics 
                            to understand and improve our website usage.
                        </p>
                        
                        <h3>5.3 Marketing Cookies</h3>
                        <p>
                            Marketing cookies are only set with your explicit consent 
                            and serve personalized advertising.
                        </p>
                        
                        <p>
                            You can change your cookie settings at any time via our cookie banner 
                            or in your browser settings.
                        </p>
                    </section>

                    <section className="legal-section">
                        <h2>6. Data Sharing</h2>
                        <p>
                            We only share your personal data in the following cases:
                        </p>
                        <ul>
                            <li>With your explicit consent</li>
                            <li>To fulfill legal obligations</li>
                            <li>To data processors (e.g., hosting providers, email services)</li>
                            <li>For legitimate interests (e.g., legal defense)</li>
                        </ul>
                        
                        <h3>6.1 Data Processors</h3>
                        <p>
                            We work with the following categories of data processors:
                        </p>
                        <ul>
                            <li>Cloud hosting providers</li>
                            <li>Email service providers</li>
                            <li>Analytics tools (Google Analytics, only with consent)</li>
                            <li>Content Delivery Networks (CDN)</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>7. Data Retention</h2>
                        <p>
                            We store your personal data only as long as necessary:
                        </p>
                        <ul>
                            <li><strong>Contact inquiries:</strong> 3 years after last contact</li>
                            <li><strong>Analytics data:</strong> 26 months (Google Analytics standard)</li>
                            <li><strong>Cookies:</strong> Depending on cookie type (see cookie settings)</li>
                            <li><strong>Legal retention requirements:</strong> Up to 10 years</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>8. Your Rights</h2>
                        <p>
                            Under GDPR, you have the following rights regarding your personal data:
                        </p>
                        <ul>
                            <li><strong>Right of access (Art. 15 GDPR):</strong> Information about processed data</li>
                            <li><strong>Right to rectification (Art. 16 GDPR):</strong> Correction of incorrect data</li>
                            <li><strong>Right to erasure (Art. 17 GDPR):</strong> Deletion of your data</li>
                            <li><strong>Right to restriction (Art. 18 GDPR):</strong> Restriction of processing</li>
                            <li><strong>Right to data portability (Art. 20 GDPR):</strong> Transfer of your data</li>
                            <li><strong>Right to object (Art. 21 GDPR):</strong> Object to processing</li>
                            <li><strong>Right to withdraw consent (Art. 7(3) GDPR):</strong> Available at any time</li>
                        </ul>
                        
                        <p>
                            To exercise your rights, contact us at: 
                            <a href="mailto:privacy@ferritico.com">privacy@ferritico.com</a>
                        </p>
                    </section>

                    <section className="legal-section">
                        <h2>9. Right to Complain</h2>
                        <p>
                            You have the right to file a complaint with a data protection supervisory authority 
                            regarding our processing of personal data. The competent authority is that of your 
                            usual place of residence, workplace, or the place of the alleged violation.
                        </p>
                        
                        <p>
                            For Sweden, this is the Swedish Authority for Privacy Protection (Integritetsskyddsmyndigheten):
                        </p>
                        <div className="contact-info-legal">
                            <p>
                                Integritetsskyddsmyndigheten<br/>
                                Postal address: Box 8114, 104 20 Stockholm<br/>
                                Phone: 08-657 61 00<br/>
                                Email: imy@imy.se<br/>
                                Website: <a href="https://www.imy.se" target="_blank" rel="noopener noreferrer">www.imy.se</a>
                            </p>
                        </div>
                    </section>

                    <section className="legal-section">
                        <h2>10. Data Security</h2>
                        <p>
                            We implement appropriate technical and organizational measures 
                            to protect your personal data from unauthorized access, loss, 
                            destruction, or manipulation:
                        </p>
                        <ul>
                            <li>SSL/TLS encryption for all data transmissions</li>
                            <li>Regular security updates</li>
                            <li>Access restrictions on personal data</li>
                            <li>Secure data centers and hosting infrastructure</li>
                            <li>Regular security audits</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>11. Contact Form and Email Contact</h2>
                        <p>
                            When you contact us via contact form or email, the data you provide 
                            will be stored to process your inquiry and for possible follow-up questions. 
                            We do not share this data without your consent.
                        </p>
                        
                        <p>
                            Processing is based on Art. 6(1)(b) GDPR if your inquiry relates to 
                            contract fulfillment or is necessary for pre-contractual measures. 
                            In all other cases, processing is based on our legitimate interest 
                            in effectively handling inquiries directed to us (Art. 6(1)(f) GDPR).
                        </p>
                    </section>

                    <section className="legal-section">
                        <h2>12. Changes to this Privacy Policy</h2>
                        <p>
                            We reserve the right to change this privacy policy to adapt it 
                            to changed legal situations or when changing the service and 
                            data processing. This only applies to statements on data processing. 
                            If user consent is required or if components of the privacy policy 
                            contain provisions of the contractual relationship with users, 
                            changes will only be made with the consent of users.
                        </p>
                        
                        <p>
                            Users are asked to inform themselves regularly about the content 
                            of the privacy policy.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
